export default __webpack_public_path__ + "static/viz/media/http.84316f43.svg";